import { defineAsyncComponent } from 'vue';
import { GlIcon, GlTooltip, GlPopover } from '@gitlab/ui';
import { s__ } from '~/locale';
import glFeatureFlagsMixin from '~/vue_shared/mixins/gl_feature_flags_mixin';
import workItemByIidQuery from '~/work_items/graphql/work_item_by_iid.query.graphql';
import { i18n } from '../../constants';
import { findHealthStatusWidget, findWeightWidget } from '../../utils';
export default {
    name: 'WorkItemRolledUpData',
    components: {
        GlIcon,
        GlTooltip,
        GlPopover,
        WorkItemRolledUpHealthStatus: defineAsyncComponent(()=>import('ee_component/work_items/components/work_item_links/work_item_rolled_up_health_status.vue'))
    },
    mixins: [
        glFeatureFlagsMixin()
    ],
    i18n: {
        progressLabel: s__('WorkItem|Progress')
    },
    props: {
        fullPath: {
            type: String,
            required: true
        },
        workItemIid: {
            type: String,
            required: false,
            default: null
        }
    },
    emits: [
        'error'
    ],
    data () {
        return {
            workItem: {},
            error: null
        };
    },
    apollo: {
        workItem: {
            query: workItemByIidQuery,
            variables () {
                return {
                    fullPath: this.fullPath,
                    iid: this.workItemIid,
                    useWorkItemFeatures: Boolean(this.glFeatures.workItemFeaturesField)
                };
            },
            update (data) {
                return data.namespace?.workItem || {};
            },
            skip () {
                return !this.workItemIid;
            },
            error (e) {
                this.$emit('error', i18n.fetchError);
                this.error = e.message || i18n.fetchError;
            }
        }
    },
    computed: {
        workItemWeight () {
            return findWeightWidget(this.workItem);
        },
        workItemHealthStatus () {
            return findHealthStatusWidget(this.workItem);
        },
        shouldRolledUpWeightBeVisible () {
            return this.rolledUpWeight !== null;
        },
        showRolledUpProgress () {
            return this.rolledUpWeight && this.rolledUpCompletedWeight !== null;
        },
        rolledUpWeight () {
            return this.workItemWeight?.rolledUpWeight;
        },
        rolledUpCompletedWeight () {
            return this.workItemWeight?.rolledUpCompletedWeight;
        },
        completedWeightPercentage () {
            return Math.round(this.rolledUpCompletedWeight / this.rolledUpWeight * 100);
        },
        rolledUpHealthStatus () {
            return this.workItemHealthStatus?.rolledUpHealthStatus;
        }
    }
};
